import React from "react";
import Styles from "../styles/Banner.module.css";

type BannerProps = {
  header: string;
};

const BannerComponent = ({ header }: BannerProps) => {
  return (
    <div className={Styles.banner}>
      <p className={Styles.heading}>{header}</p>
    </div>
  );
};

export default BannerComponent;
